import { Component, OnInit } from '@angular/core';
import { PROVINCES } from '../../../data/provinces';
import { Client } from '../../../../classes/Client';
import { Supplier } from '../../../../classes/Supplier';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.css']
})
export class AddClientComponent implements OnInit {

  provinces = PROVINCES;

  isSubmitButtonDisabled: boolean = false;
  newClient: Client = new Client( );
  addSupplierButtonDisabled: boolean = true;
  
  availableRoles: string[] = [ 'admin', 'manager', 'sales' ];
  isAvailable: boolean = true;
  suppliers: Supplier[] = [];
  selectedSuppliers: any = {};

  customAdmins = [];

  selectParams: any = {

    referredBy: {
      id: 'inputReferredBy',
      isRequired: true,
      change: ( event ) => { this.newClient.referredBy = event.value; },
      options: [ { text: '', value: '' } ]
    },
    
    billingState: {
      id: 'inputBillingState',
      isRequired: true,
      change: ( event ) => {
        this.newClient.BillingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    },

    shippingState: {
      id: 'inputShippingState',
      isRequired: true,
      change: ( event ) => {
        this.newClient.ShippingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    },

    suppliers: []

  };


  constructor ( 
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Add Client' ); 
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
    this.newClient.suppliers = [{
      supplier_id: '',
      supplierAccountNumber: ''
    }];


    this.provinces.forEach( _state => {
      this.selectParams.billingState.options.push( { text: _state.long, value: _state.short } );
      this.selectParams.shippingState.options.push( { text: _state.long, value: _state.short } );
    });
    // this.selectParams.suppliers.push({
    //   id: 'selectSupplier',
    //   isRequired: true,
    //   change: ( event ) => { 
    //     this.newClient.suppliers[0] = event.value;
    //     this.checkSupplier( ); 
    //   },
    //   options: [ { text: '', value: '' } ]  
    // });

  }

  ngOnInit ( ) { 

    this.model.getSuppliersData( ( spData ) => {
      this.suppliers = spData;
      this.checkSupplier( );
    }, { 'sorting': 'name' });

    this.model.getCustomAdmins( ( customAdmins ) => { 
      this.customAdmins = customAdmins; 
      customAdmins.forEach( _admin => {
        this.selectParams.referredBy.options.push( { text: _admin.firstName+' '+_admin.secondName ,value: _admin.id } );
      });
    });

  }


  trackByIndex( index: number, obj: any ): any {
    return index;
  }


  addSupplier ( ) {
    this.newClient.suppliers.push({
      supplier_id: '',
      supplierAccountNumber: ''
    });
    this.checkSupplier( );
  }

  checkSupplier ( fromInput?:boolean ) {
    let i;
    this.addSupplierButtonDisabled = false;
    this.selectedSuppliers = {};
    for ( i = 0; i < this.newClient.suppliers.length; ++i ) {
      this.selectedSuppliers[this.newClient.suppliers[i].supplier_id] = i;
      if ( !this.newClient.suppliers[i].supplier_id || this.newClient.suppliers[i].supplierAccountNumber == '' ) this.addSupplierButtonDisabled = true;
    }

    if ( fromInput != true ) this.generateSuppliersSelectParams( );

  }

  generateSuppliersSelectParams (  ) { 

    this.selectParams.suppliers = [];

    this.newClient.suppliers.forEach( ( _cSupplier, ind ) => {

      let _SO = {
        isRequired: true,
        change: ( event ) => {
          this.newClient.suppliers[ind].supplier_id = event.value;
          this.checkSupplier( );
        },
        options: [ ],
        selectedValue: this.newClient.suppliers[ind].supplier_id,
        elementID: ''
      };

      let _options = [{ text: '', value: '' }];

      if ( ind == 0 ) _SO.elementID = 'selectSupplier';

      this.suppliers.forEach( _supplier => {
        if ( !( ( this.selectedSuppliers[_supplier.id] || this.selectedSuppliers[_supplier.id] == 0 ) && this.selectedSuppliers[_supplier.id] !== ind ) ) {
          _options.push( { text: _supplier.name, value: _supplier.id } );
        }
      });

      _SO.options = _options;

      this.selectParams.suppliers.push( _SO );

    });

  }

  removeSupplier ( _i: number ) {
    this.newClient.suppliers.splice( _i, 1 );
    this.checkSupplier( );
  }

  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'New client has been added successfully', 
      redirect: '/clients-list' 
    });
  }

  errorCallback ( message ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.global.defaultErrorCallback( message, false );
    this.isSubmitButtonDisabled = false;

  }

  submitForm ( ) {

    if ( this.newClient.SameAsBillingAddress ) {
      this.newClient.ShippingStreet  = this.newClient.BillingStreet;
      this.newClient.ShippingCity    = this.newClient.BillingCity;
      this.newClient.ShippingState   = this.newClient.BillingState;
      this.newClient.ShippingZipCode = this.newClient.BillingZipCode;
      this.newClient.ShippingCountry = this.newClient.BillingCountry;
    }

    this.isSubmitButtonDisabled = true;
    this.model.addClient( this.newClient, ( response ) => {
      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else this.errorCallback( _answer );
    });
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/clients-list' );
  }


}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/clients/add-client/add-client.component.ts